<template>
  <div class="cotent hp_center">
    <div>
      <img src="@/assets/error/404.png" alt />
    </div>
    <div class="tip">出错啦！你访问的页面没找着！</div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.cotent {
  width: 100%;
  min-height: 100vh;
  background-color: #2b7bff;
  flex-wrap: wrap;
}
.tip {
  width: 100%;
  font-size: 42px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
}
</style>